import React from "react";
import FooterWrapper from "./footer.style";
import Icons_visa from "../../assets/images/pay/Icons_visa.svg";
import Icons_mada from "../../assets/images/pay/Icons_mada.svg";
import Icons_mastercard from "../../assets/images/pay/Icons_mastercard.svg";
import Icons_Amex from "../../assets/images/pay/Icons_Amex.svg";
import Icons_Sadad from "../../assets/images/pay/Icons_Sadad.svg";
import facebbok_logo from "../../assets/images/socials/Facebook.svg";
import youtube_logo from "../../assets/images/socials/Youtube.svg";
import twitter_logo from "../../assets/images/socials/Twitter.svg";
import lnkedin_logo from "../../assets/images/socials/LinkedIN.svg";
import instagram_logo from "../../assets/images/socials/Instagram.svg";
import { withTranslation } from "react-i18next";
import "./styles.css";

const Footer = ({ i18n }) => {
  return (
    <FooterWrapper>
      <footer
        dir={i18n.language === "ar" ? "rtl" : "ltr"}
        className={i18n.language === "ar" ? "ar" : ""}
      >
        <div className="wrapper">
          <div className="container">
            <div className="row">
              <div className="col-12">
                <div className="wrapper">
                  <div className="item">
                    <p>
                      {i18n.t("FOOTER.COPY")} {new Date().getFullYear()}{" "}
                      {i18n.t("FOOTER.RIGHTS")}{" "}
                    </p>
                  </div>
                  <div className="item ">
                    <a href="https://www.tawuniya.com/#/privacy-policy">
                      {i18n.t("FOOTER.PRIVACY_POLICY")}
                    </a>
                  </div>
                  {/* <div className="item payments">
                    <div>
                      <img src={Icons_visa} alt="" />
                    </div>
                    <div>
                      <img src={Icons_mada} alt="" />
                    </div>
                    <div>
                      <img src={Icons_mastercard} alt="" />
                    </div>
                    <div>
                      <img src={Icons_Amex} alt="" />
                    </div>
                    <div>
                      <img src={Icons_Sadad} alt="" />
                    </div>
                  </div> */}
                  {/* <div className="item socials">
                    <a
                      href="https://www.facebook.com/Tawuniya"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <img src={facebbok_logo} alt="" />
                    </a>
                    <a
                      href="https://www.youtube.com/tawuniya"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <img src={youtube_logo} alt="" />
                    </a>
                    <a
                      href="https://twitter.com/tawuniya"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <img src={twitter_logo} alt="" />
                    </a>
                    <a
                      href="https://www.linkedin.com/company/tawuniya"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <img src={lnkedin_logo} alt="" />
                    </a>
                    <a
                      href="https://www.instagram.com/tawuniya"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <img src={instagram_logo} alt="" />
                    </a>
                  </div> */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </FooterWrapper>
  );
};
export default withTranslation()(Footer);
